/**
 * Free Shipping Progress Bar & Banner
 * Threshold: $100 (10000 cents)
 */

(function() {
  // Configuration
  const FREE_SHIPPING_THRESHOLD = 10000; // $100 in cents
  
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0);
  }
  
  function updateFreeShippingProgress(cartTotal) {
    const containers = document.querySelectorAll('.free-shipping-progress-container');
    const banner = document.getElementById('free-shipping-banner');
    
    containers.forEach(function(container) {
      const messageEl = container.querySelector('.free-shipping-message');
      const progressBar = container.querySelector('.progress-bar');
      const wrapper = container.querySelector('.progress-bar-wrapper');
      
      const remaining = FREE_SHIPPING_THRESHOLD - cartTotal;
      const progress = Math.min((cartTotal / FREE_SHIPPING_THRESHOLD) * 100, 100);
      
      if (progressBar) {
        progressBar.style.width = progress + '%';
      }
      
      if (wrapper) {
        if (progress >= 100) {
          wrapper.classList.add('complete');
        } else {
          wrapper.classList.remove('complete');
        }
      }
      
      if (messageEl) {
        if (remaining > 0) {
          messageEl.innerHTML = 'Add <span class="amount">' + formatMoney(remaining) + '</span> more for free shipping!';
        } else {
          messageEl.innerHTML = '<span class="success">🎉 You\'ve got free shipping!</span>';
        }
      }
    });
    
    // Update banner visibility
    if (banner) {
      if (cartTotal >= FREE_SHIPPING_THRESHOLD) {
        banner.classList.remove('hide');
        banner.classList.add('show');
        document.body.style.paddingTop = banner.offsetHeight + 'px';
      } else {
        banner.classList.remove('show');
        banner.classList.add('hide');
        document.body.style.paddingTop = '0';
      }
    }
  }
  
  // Check cart on page load
  function initFreeShipping() {
    if (typeof Shopify !== 'undefined') {
      Shopify.getCart(function(cart) {
        updateFreeShippingProgress(cart.total_price);
      });
    }
  }
  
  // Update when cart changes (hook into existing cart functions)
  if (typeof Shopify !== 'undefined' && Shopify.updateCartFromLineItems) {
    var originalUpdateCart = Shopify.updateCartFromLineItems;
    Shopify.updateCartFromLineItems = function(cart) {
      updateFreeShippingProgress(cart.total_price);
      return originalUpdateCart.apply(this, arguments);
    };
  }
  
  // Also hook into adjustCartDropDown if it exists
  if (typeof adjustCartDropDown === 'function') {
    var originalAdjustCart = adjustCartDropDown;
    window.adjustCartDropDown = function() {
      if (typeof Shopify !== 'undefined') {
        Shopify.getCart(function(cart) {
          updateFreeShippingProgress(cart.total_price);
        });
      }
      return originalAdjustCart.apply(this, arguments);
    };
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFreeShipping);
  } else {
    initFreeShipping();
  }
  
  // Listen for cart update events
  document.addEventListener('cart:updated', function(e) {
    if (e.detail && e.detail.total_price !== undefined) {
      updateFreeShippingProgress(e.detail.total_price);
    }
  });
})();
